export function addListenerToSocket(source_id) {
  // add this source_id to listeners in socket connection
  this.$socket.on(source_id, ({ action, data }) => {
    console.log("SOCKET UPDATING DATA", data, action);
    // const ids = Object.keys(data);

    switch (action) {
      case "update":
        this.$store.commit("UPDATE_ACTIVE_OBJECT_INFO", { data, source_id }); // update card
        this.$store.commit("UPDATE_ACTIVE_BOOKTABLE", {
          data,
          source_id,
          action
        }); // update new-book
        // this.$store.commit("UPDATE_CHART", { data, source_id }); // update chart
        break;
      case "create":
        this.$store.commit("ADD_OBJECT_INFO", { data, source_id }); // add to store
        this.$store.commit("UPDATE_ACTIVE_BOOKTABLE", {
          data,
          source_id,
          action
        }); // update new-book
        break;
      case "delete":
        this.$store.commit("DELETE_OBJECT_INFO", { ids: data, source_id }); // delete from store
        this.$store.commit("UPDATE_ACTIVE_BOOKTABLE", {
          data,
          source_id,
          action
        }); // update new-book
        break;
    }
  });
}
